import ApiKeysTableHeader from './ApiKeysTableHeader'

export default ApiKeysTableHeader
